<template>
  <ul v-if="dataIsLoad">
    <li
      v-for="color in itemDatas.Colors"
      :key="color.ID"
      :class="{ active: color.ID === selectedData.ID }"
      @click.prevent="changeImg(color.ID)"
    >
      <a href="javascript:;">
        <img :src="color.PintSizePictureUrl" :alt="color.Name" :title="color.Name" />
      </a>
    </li>
  </ul>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ColorButton',
  computed: {
    ...mapState('shopContent', ['selectedData', 'itemDatas', 'dataIsLoad']),
  },
  methods: {
    ...mapActions('shopContent', ['changeImg']),
  },
};
</script>
